import type { Store } from 'vuex';

import {
	withAccessToken,
	withAuthMiddleware,
	withHeaders,
	withHttpLink,
	withRecommanderHeader,
	withResponseLogger,
} from '@/graphql/utils/links';

export type ServerHeaders = { [key: string]: string };

export interface ApolloClientConfig {
	store: Store<any>;
	headers?: ServerHeaders;
	ssr?: boolean;
}

const getServerLinks = async ({ store, headers }: ApolloClientConfig) => {
	const serverLinks = [
		withAccessToken(store),
		withRecommanderHeader(store),
		withAuthMiddleware(store),
		withHeaders(headers) /* , withRetry() */,
	];
	if (process.server && global.DEBUG_APOLLO === 'true') {
		serverLinks.push(withResponseLogger(headers));
	}
	serverLinks.push(withHttpLink());

	return serverLinks;
};

const getClientLinks = async ({ store, headers }: ApolloClientConfig) => {
	const clientLinks = [
		withAccessToken(store),
		withRecommanderHeader(store),
		withAuthMiddleware(store),
		withHttpLink(),
	];

	if (headers) {
		clientLinks.unshift(withHeaders(headers));
	}
	return clientLinks;
};

export { getClientLinks, getServerLinks };
